import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { Button, InputGroup, Tab, Tabs } from "react-bootstrap";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import { Helmet } from "react-helmet-async";
import {
  FaBox,
  FaChartBar,
  FaClipboardList,
  FaMoneyBillWave,
  FaWarehouse,
} from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import AnalyticRaportAdetlerVeTutarlar from "../components/AnalyticRaportAdetlerVeTutarlar";
import CiroAndHarcamaTablo from "../components/CiroAndHarcamaTablo";
import KalemlerBarChart from "../components/KalemlerBarChart";
import KalemlerPieChart from "../components/KalemlerPieChart";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import OrdersTableList from "../components/OrdersTableList";
import StockTable from "../components/StockTable";
import useAxios from "../hooks/useAxios";
import {
  applyPreviuosMonthStock,
  getError,
  getMonthlyStocksReFormatted,
  getTimeDifferenceAsMinutesAndHours,
  getWeekNumber,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import ExpenseListScreen from "./ExpenseListScreen";
import ScatterChartForOrders from "./ScatterOrderChart";
import ScatterChartForOrderItems from "./ScatterOrderItemChart";

const graphTypes = [
  { type: "none", name: "Liste" },
  {
    type: "bar",
    name: "Çubuk Grafik",
  },
  { type: "cake", name: "Pasta Grafiği" },
];

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default function PeriodicReportScreen() {
  const navigate = useNavigate();
  const axios = useAxios();
  const descriptionRef = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState({ product: "" });
  const [graphType, setGraphType] = useState("none");
  const [activeTab, setActiveTab] = useState("ozet");
  const [selectedProductGift, setSelectedProductGift] = useState({
    product: "",
  });
  const [netStockAmount, setNetStockAmount] = useState();
  const [{ loading, error, categories, products }, dispatch] = useReducer(
    reducer,
    {
      loading: true,
      error: "",
      categories: [],
      products: [],
    }
  );

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, carts, table, categoryHistory, mostUsedProducts } = state;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [periodReport, setPeriodReport] = useState();
  const [showAmount, setShowAmount] = useState(true);
  const [previousPeriodStock, setPreviousPeriodStock] = useState({
    netStocks: [],
  });
  const today = new Date();
  const [reportDate, setReportDate] = useState(today);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const reportdateFromSummary = sp.get("reportDate");
  const typeFromSummary = sp.get("type");

  const fetchDailyReportByDate = async (reportDate) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: dailyReportData } = await axios.get(
        `/api/orders/dailyreportbydate?startedAt=${reportDate.toISOString()}`
      );

      setPeriodReport(dailyReportData.dailyReport);

      const previousDay = reportDate
        ? new Date(reportDate.getTime())
        : new Date();
      previousDay.setDate(previousDay.getDate() - 1);
      const { data: dailyReportDataPrevious } = await axios.get(
        `/api/orders/dailyreportbymaxlinenum?startLineNum=${dailyReportData.dailyReport?.startLineNum}`
      );
      setPreviousPeriodStock(
        dailyReportDataPrevious.dailyReport || { netStocks: [] }
      );

      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  const fetchMonthlyReportByDate = async (reportDate) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: monthlyReportData } = await axios.get(
        `/api/orders/monthlyreportbydate?reportDate=${reportDate.toISOString()}`
      );

      const previousMonth = new Date(reportDate.getTime());
      previousMonth.setMonth(previousMonth.getMonth() - 1);
      const { data: monthlyNetStockData } = await axios.get(
        `/api/orders/monthlyNetStock?reportDate=${previousMonth.toISOString()}`
      );
      setPreviousPeriodStock(
        monthlyNetStockData.monthlyStock || { netStocks: [] }
      );
      setPeriodReport(monthlyReportData.monthlyReport);
      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  const fetchAnnualReportByDate = async (reportDate) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: annualReportData } = await axios.get(
        `/api/orders/annualreportbydate?reportDate=${reportDate.toISOString()}`
      );

      const previousYear = new Date(reportDate.getTime());
      previousYear.setFullYear(previousYear.getFullYear() - 1);
      const { data: annualNetStockData } = await axios.get(
        `/api/orders/annualNetStock?reportDate=${previousYear.toISOString()}`
      );
      setPreviousPeriodStock(
        annualNetStockData.annualStock || { netStocks: [] }
      );
      setPeriodReport(annualReportData.annualReport);
      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  const fetchWeeklyReportByDate = async (reportDate) => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data: weeklyReportData } = await axios.get(
        `/api/orders/weeklyreportbydate?reportDate=${reportDate.toISOString()}`
      );

      const previousWeek = new Date(reportDate.getTime());
      previousWeek.setDate(previousWeek.getDate() - 7);
      const { data: weeklyNetStockData } = await axios.get(
        `/api/orders/weeklyNetStock?reportDate=${previousWeek.toISOString()}`
      );
      setPreviousPeriodStock(
        weeklyNetStockData.weeklyStock || { netStocks: [] }
      );
      setPeriodReport(weeklyReportData.weeklyReport);
      dispatch({ type: "FETCH_SUCCESS" });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL" });
      toast(getError(err));
    }
  };

  useEffect(() => {
    if (reportdateFromSummary) {
      const reportDate = new Date(reportdateFromSummary);
      setReportDate(reportDate);
      if (typeFromSummary === "daily") {
        fetchDailyReportByDate(reportDate);
      } else if (typeFromSummary === "monthly") {
        fetchMonthlyReportByDate(reportDate);
      } else if (typeFromSummary === "weekly") {
        fetchWeeklyReportByDate(reportDate);
      } else {
        fetchAnnualReportByDate(reportDate);
      }
    }
  }, [reportdateFromSummary]);

  return (
    <div>
      <Helmet>
        <title>Detaylı Rapor</title>
      </Helmet>

      <div>
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab
            eventKey="ozet"
            title={
              <>
                <FaClipboardList /> Özet
              </>
            }
          >
            <Row>
              <Col md={6}>
                {loading ? (
                  <LoadingBox></LoadingBox>
                ) : (
                  <>
                    {periodReport ? (
                      <div>
                        <table className="table">
                          <tbody>
                            <tr className="table-primary">
                              <td className="text-bold">
                                {typeFromSummary === "daily"
                                  ? "Gün"
                                  : typeFromSummary === "monthly"
                                  ? "Ay"
                                  : typeFromSummary === "weekly"
                                  ? "Hafta"
                                  : "Yıl"}
                              </td>
                              <td>
                                {typeFromSummary === "daily"
                                  ? reportDate.toLocaleDateString("tr-TR", {
                                      weekday: "long",
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    })
                                  : typeFromSummary === "monthly"
                                  ? reportDate.toLocaleDateString("tr-TR", {
                                      year: "numeric",
                                      month: "long",
                                    })
                                  : typeFromSummary === "weekly"
                                  ? `${getWeekNumber(
                                      reportDate
                                    )}.Hafta ${new Date(
                                      reportDate
                                    ).getFullYear()}`
                                  : reportDate.toLocaleDateString("tr-TR", {
                                      year: "numeric",
                                    })}
                              </td>
                            </tr>
                            <tr className="table-primary">
                              <td className="text-bold">Açılış</td>
                              <td>
                                {new Date(periodReport.startedAt)
                                  .toLocaleString("tr-TR")
                                  .substring(0, 16)}
                                &nbsp;
                                <span className="small-font text-muted">
                                  No: {periodReport.startLineNum}
                                </span>
                              </td>
                            </tr>
                            <tr className="table-primary">
                              <td className="text-bold">Kapanış</td>
                              <td>
                                {periodReport.finishedAt
                                  ? new Date(periodReport.finishedAt)
                                      .toLocaleString("tr-TR")
                                      .substring(0, 16)
                                  : new Date()
                                      .toLocaleString("tr-TR")
                                      .substring(0, 16)}
                                &nbsp;
                                <span className="small-font text-muted">
                                  No: {periodReport.endLineNum}
                                </span>
                              </td>
                            </tr>
                            <tr className="table-primary">
                              <td className="text-bold">Masa/Sipariş Sayısı</td>
                              <td>
                                {periodReport.endLineNum -
                                  periodReport.startLineNum +
                                  1}
                              </td>
                            </tr>
                            {typeFromSummary === "daily" && (
                              <tr className="table-primary">
                                <td className="text-bold">İlk Sipariş</td>
                                <td>
                                  {new Date(
                                    periodReport.firstOrder.orderItems[0].createdAt
                                  ).toLocaleTimeString("tr-TR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </td>
                              </tr>
                            )}

                            {typeFromSummary === "daily" && (
                              <tr className="table-primary">
                                <td className="text-bold">Son Sipariş</td>
                                <td>
                                  {new Date(
                                    periodReport.lastOrder.createdAt
                                  ).toLocaleTimeString("tr-TR", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </td>
                              </tr>
                            )}

                            {typeFromSummary === "daily" && (
                              <tr className="table-primary">
                                <td className="text-bold">Aktif Süre</td>
                                <td>
                                  {getTimeDifferenceAsMinutesAndHours(
                                    new Date(
                                      periodReport.firstOrder.orderItems[0].createdAt
                                    ),
                                    new Date(periodReport.lastOrder.createdAt)
                                  )}
                                </td>
                              </tr>
                            )}

                            {periodReport._id && (
                              <>
                                {" "}
                                {!!periodReport.excessCache && (
                                  <tr className="table-primary">
                                    <td className="text-bold">
                                      Eksik Çıkan Nakit
                                    </td>
                                    <td>
                                      {turkishCurrencyFormatterNoPrecision(
                                        periodReport.excessCache
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {!!periodReport.missingCache && (
                                  <tr className="table-primary">
                                    <td className="text-bold">
                                      Fazla Çıkan Nakit
                                    </td>
                                    <td>
                                      {turkishCurrencyFormatterNoPrecision(
                                        periodReport.missingCache
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {!!periodReport.description && (
                                  <tr className="table-primary">
                                    <td className="text-bold">Açıklama</td>
                                    <td>{periodReport.description}</td>
                                  </tr>
                                )}
                              </>
                            )}
                          </tbody>
                        </table>

                        <CiroAndHarcamaTablo
                          periodReport={periodReport}
                          netStockAmount={netStockAmount}
                        />
                      </div>
                    ) : (
                      <MessageBox variant="danger">
                        {`Bu tarihte işlem yapılmamış!`}
                      </MessageBox>
                    )}
                  </>
                )}
              </Col>
              {!loading && (
                <Col md={6}>
                  {periodReport && typeFromSummary === "daily" && (
                    <ScatterChartForOrderItems
                      startLineNum={periodReport.startLineNum}
                      endLineNum={periodReport.endLineNum}
                    />
                  )}
                  {periodReport && typeFromSummary !== "daily" && (
                    <ScatterChartForOrders
                      startLineNum={periodReport.startLineNum}
                      endLineNum={periodReport.endLineNum}
                    />
                  )}
                </Col>
              )}
            </Row>
          </Tab>

          <Tab
            eventKey="tables"
            title={
              <>
                <FaBox /> Siparişler
              </>
            }
          >
            {activeTab === "tables" && (
              <OrdersTableList
                startLineNum={periodReport.startLineNum}
                endLineNum={periodReport.endLineNum}
              />
            )}
          </Tab>

          <Tab
            eventKey="details"
            title={
              <>
                <FaChartBar /> Kalemler
              </>
            }
          >
            <div className="row">
              <div className="col-md-9">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  <div>
                    <InputGroup
                      size={"md"}
                      className="mb-3"
                      style={isTabletOrMobile ? {} : { marginLeft: "20px" }}
                    >
                      {graphTypes.map((t) => (
                        <Button
                          key={t.name}
                          variant={
                            graphType === t.type
                              ? "primary"
                              : "outline-secondary"
                          }
                          onClick={() => {
                            setGraphType(t.type);
                          }}
                        >
                          {t.name}
                        </Button>
                      ))}
                    </InputGroup>
                  </div>
                  {graphType !== "none" && (
                    <div>
                      <InputGroup
                        size={"md"}
                        className="mb-3"
                        style={isTabletOrMobile ? {} : { marginLeft: "20px" }}
                      >
                        <Button
                          variant={showAmount ? "primary" : "outline-secondary"}
                          onClick={() => {
                            setShowAmount(true);
                          }}
                        >
                          Adetler
                        </Button>
                        <Button
                          variant={
                            !showAmount ? "primary" : "outline-secondary"
                          }
                          onClick={() => {
                            setShowAmount(false);
                          }}
                        >
                          Tutarlar
                        </Button>
                      </InputGroup>
                    </div>
                  )}
                </div>
                {periodReport &&
                  (graphType === "bar" ? (
                    <KalemlerBarChart
                      periodReport={periodReport}
                      showAmount={showAmount}
                    />
                  ) : graphType === "cake" ? (
                    <KalemlerPieChart
                      periodReport={periodReport}
                      showAmount={showAmount}
                    />
                  ) : (
                    <AnalyticRaportAdetlerVeTutarlar
                      dailyReport={periodReport}
                      selectedProduct={selectedProduct}
                      setSelectedProduct={setSelectedProduct}
                      selectedProductGift={selectedProductGift}
                      setSelectedProductGift={setSelectedProductGift}
                    />
                  ))}
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="expenses"
            title={
              <>
                <FaMoneyBillWave /> Harcamalar
              </>
            }
          >
            {periodReport && !loading && (
              <ExpenseListScreen
                queryStartDate={periodReport.startedAt}
                queryEndDate={periodReport.finishedAt || new Date()}
                forReport={true}
                pageSize={6}
                miktarDesc={true}
              ></ExpenseListScreen>
            )}
          </Tab>

          <Tab
            eventKey="stocks"
            title={
              <>
                <FaWarehouse /> Stoklar
              </>
            }
          >
            {!loading && (
              <Col md={6}>
                {periodReport && (
                  <StockTable
                    type={typeFromSummary}
                    reportDate={reportDate}
                    netStockAmount={netStockAmount}
                    setNetStockAmount={setNetStockAmount}
                    stocks={applyPreviuosMonthStock(
                      getMonthlyStocksReFormatted(periodReport.netStocks),
                      getMonthlyStocksReFormatted(previousPeriodStock.netStocks)
                    ).sort((s1, s2) => s2.totalCost - s1.totalCost)}
                  ></StockTable>
                )}
              </Col>
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
